import employeeReviewApi from "../../api/rest/employeeReviewApi";

const getMyConsolidatedReview = async () => {
  const data = await employeeReviewApi.getMyConsolidatedReview();
  return data;
}

export const employeeReviewBusiness = {
  getMyConsolidatedReview,
};